import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Search } from "lucide-react";
import api, { asList } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";

const CATS = [
  { key: "todos", label: "Todos" },
  { key: "granel", label: "Granel" },
  { key: "suplementos", label: "Suplementos" },
  { key: "chas", label: "Chás e Ervas" },
  { key: "alimentos", label: "Alimentos Naturais" },
  { key: "cosmeticos", label: "Cosméticos Naturais" },
  { key: "kits", label: "Kits e Presentes" },
];

export default function Shop() {
  const [params, setParams] = useSearchParams();
  const cat = params.get("cat") || "todos";
  const [products, setProducts] = useState([]);
  const [q, setQ] = useState(params.get("q") || "");
  const [sort, setSort] = useState("destaque");

  useEffect(() => {
    api.get("/products").then((r) => setProducts(asList(r.data))).catch(() => setProducts([]));
  }, []);
  useEffect(() => { setQ(params.get("q") || ""); }, [params]);

  const setCat = (key) => {
    const p = {};
    if (key !== "todos") p.cat = key;
    if (q) p.q = q;
    setParams(p);
  };

  const filtered = useMemo(() => {
    let list = asList(products).filter((p) => (cat === "todos" ? true : p.category === cat));
    if (q) list = list.filter((p) => p.name.toLowerCase().includes(q.toLowerCase()));
    if (sort === "menor") list = [...list].sort((a, b) => a.price - b.price);
    if (sort === "maior") list = [...list].sort((a, b) => b.price - a.price);
    if (sort === "destaque") list = [...list].sort((a, b) => (b.bestseller ? 1 : 0) - (a.bestseller ? 1 : 0));
    return list;
  }, [products, cat, q, sort]);

  return (
    <div className="mx-auto max-w-[1280px] px-4 py-10 sm:px-6">
      <nav className="mb-4 font-sans text-xs text-ink/50">Início / <span className="text-forest-deep">Loja</span></nav>
      <h1 className="font-serif text-3xl font-semibold text-forest-deep sm:text-4xl">Nossos Produtos</h1>

      <div className="mt-6 flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex flex-wrap gap-2">
          {CATS.map((c) => (
            <button key={c.key} onClick={() => setCat(c.key)} data-testid={`category-filter-${c.key}`}
              className={`rounded-full border px-4 py-2 font-sans text-sm transition-colors ${
                cat === c.key ? "border-forest-deep bg-forest-deep text-white" : "border-borderlight bg-white text-ink hover:border-clay hover:text-clay"
              }`}>
              {c.label}
            </button>
          ))}
        </div>
        <div className="flex items-center gap-3">
          <div className="flex items-center rounded-full border border-borderlight bg-white px-3">
            <Search size={15} className="text-ink/40" />
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar..." data-testid="shop-search"
              className="w-36 bg-transparent px-2 py-2 font-sans text-sm outline-none" />
          </div>
          <select value={sort} onChange={(e) => setSort(e.target.value)} data-testid="shop-sort"
            className="rounded-full border border-borderlight bg-white px-4 py-2 font-sans text-sm outline-none">
            <option value="destaque">Destaque</option>
            <option value="menor">Menor preço</option>
            <option value="maior">Maior preço</option>
          </select>
        </div>
      </div>

      {filtered.length === 0 ? (
        <p className="py-24 text-center font-serif text-2xl text-ink/40">Nenhum produto encontrado.</p>
      ) : (
        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {filtered.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
